import { useWSModal } from "@wingspanhq/fe-component-library";
import { EditRequirementDefinitionModal } from "./index";

export function useEditRequirementDefinitionModal() {
  return useWSModal(EditRequirementDefinitionModal, {
    title: "Edit requirement",
    size: "S"
  });
}
